import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-tabs-item',
  templateUrl: './tabs-item.component.html',
  styleUrls: ['./tabs-item.component.css'],
  imports: [CommonModule],
})
export class TabsItemComponent {
  @Input() title!: string;
  @Input() active!: boolean;
}
